import { render, staticRenderFns } from "./SmsCodes.vue?vue&type=template&id=7bbbbe02"
import script from "./SmsCodes.vue?vue&type=script&lang=js"
export * from "./SmsCodes.vue?vue&type=script&lang=js"
import style0 from "./SmsCodes.vue?vue&type=style&index=0&id=7bbbbe02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports